module.exports = __webpack_public_path__ + "img/img_qr_loading.af6bccc6.png";